import type { Route } from 'vue-router'
import type {
  IEntityMaskData,
  TEntityMaskItem,
  IEntityParentObjectForCreate,
  TEntityMaskDataValueTypes,
} from '~/types/models'

// Shape of the context object passed to an inputFields spec's `default()` function.
// `ifield.default` is declared on IEntityMaskData as a plain value union
// (TEntityMaskDataValueTypes), so we cast to this fn type when it is callable.
type TEntityMaskDefaultFn = (ctx: {
  route: Route
  thisField: IEntityMaskData
  entityParentObjectForCreate?: IEntityParentObjectForCreate
  inputFields: TEntityMaskItem[]
  isSubentityDialog?: boolean
}) => TEntityMaskDataValueTypes | Promise<TEntityMaskDataValueTypes>

interface IGetInputFieldDefaultValueParams {
  route: Route
  ifield: IEntityMaskData
  entityParentObjectForCreate?: IEntityParentObjectForCreate
  inputFields: TEntityMaskItem[]
  isSubentityDialog?: boolean
}

export async function getInputFieldDefaultValue({
  route,
  ifield,
  entityParentObjectForCreate,
  inputFields,
  isSubentityDialog,
}: IGetInputFieldDefaultValueParams): Promise<TEntityMaskDataValueTypes> {
  if (typeof ifield.default === 'undefined') {
    return undefined
  }
  return typeof ifield.default === 'function'
    ? await (ifield.default as TEntityMaskDefaultFn)({
        route,
        thisField: ifield, // name swap for clarity in context of an ifield.default function definition in an inputFields spec file
        entityParentObjectForCreate,
        inputFields,
        isSubentityDialog,
      })
    : ifield.default
}
